


























// lets use composition api here to defineComponent
export default {
  name: 'PhoneInfo',
  data(): { menu: boolean; phoneNumber: string } {
    return {
      menu: false,
      phoneNumber: 'XXX-XXX-XXXX', //dont want to actually display my phone # in plain text
    }
  },
  methods: {
    // add notification to user that action was completed
    copyPhoneNumber(): void {
      navigator.clipboard.writeText('216-309-0166')
    }
  }
}
